import { clsx } from 'clsx'
import { Banner } from 'component/Banner/Banner'
import { Button } from 'component/Button'
import { Loader } from 'component/Loader/Loader'
import { ProfileSelect } from 'component/ProfileSelect'
import { Space } from 'component/Space'
import { Gap } from 'component/Space/Gap'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useEffectOnce } from 'hook/useEffectOnce'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n, I18nKey } from 'i18n'
import { observer } from 'mobx-react-lite'
import { Page } from 'page/Page/Page'
import { CombineBanner } from 'page/StartScreen/combine/CombineBanner'
import { ItemsPane } from 'page/StartScreen/ItemsPane'
import { useCallback, useState } from 'react'
import { controller } from 'store/controller'
import { opt } from 'store/opt'
import { store } from 'store/store'
import css from './StartScreen.module.scss'

export const StartScreen = observer(() => {
  if (store.item) {
    return <Ready />
  }

  return (
    <Page clear center noBack={!opt.close_back}>
      <Loader />
    </Page>
  )
})

const Ready = observer(() => {
  const item = store.item!
  const combine = !!opt.options.combine && item.combine && !store.comboItemId
  const { identity_id, saving } = store.profile
  const good = !!identity_id || !!saving
  const [show, setShow] = useState(false)
  const combine_step = item.step !== 'none'
  const no_limit = !!identity_id && !store.available
  const exceededLimitType = store.exceededLimitType || ''
  const limitText = i18n(`LimitTextShot${exceededLimitType}` as I18nKey)
  const limitTextTryAgain = i18n(`LimitTextTryAgain${exceededLimitType}` as I18nKey)

  useEffectOnce(() => setShow(true))

  const onCreate = useCallback(async () => {
    controller.onClickTry()
    if (good) await controller.generateLook()
    else controller.openCreateProfile('generate')
  }, [good])

  const onCombine = useLatestCallback(() => {
    if (good) controller.openCombineScreen()
    else controller.editProfile('combine')
  })

  const profiles = store.identities.profiles.length > 1

  const buttons = (<Space wide gap={10}>
    <Button
      large
      wide
      primary
      action={onCreate}
      disabled={no_limit}
    >
      {i18n('TryItOnForYourself')}
    </Button>
    {combine && (
      <Button large wide action={onCombine} disabled={no_limit}>
        {i18n('CombineLook')}
      </Button>
    )}
  </Space>)

  return (
    <Page clear tall noBack={!opt.close_back}>
      <Vertical className={clsx(show ? css.show : css.hide)} center tall wide oh>
        <Vertical maxWidth="var(--max-width)" minWidth={240} wide tall oh>
          <ItemsPane />
          <Gap height={16} spring />
          {no_limit && (
            <Vertical wide pad={12} gap={4} center className={css.limit}>
              <Typo center semi>{limitText}</Typo>
              <Typo center>{limitTextTryAgain}</Typo>
            </Vertical>
          )}
          {!no_limit && (
            <>
              {profiles ? (<>
                <Gap height={200} />
                <Banner canClose={false}>
                  <Space wide center>
                    <Typo size={15} secondary center>
                      {i18n('SelectProfile')}
                    </Typo>
                  </Space>
                  <Gap height={24} />
                  <ProfileSelect inline />
                  <Gap height={20} />
                  {buttons}
                </Banner>
              </>) : (
                buttons
              )}
            </>
          )}
        </Vertical>
      </Vertical>
      {combine_step && <CombineBanner />}
    </Page>
  )
})
